<template>
  <div class="circle">
    <div class="body">
      <div class="nav">
        <img src="@/assets/webp.png" alt />
        <div class="home" @click="skip"></div>
        <div class="name">
          <div class="name_img">
            <span>{{ liaotjl.name }}</span>
            <img :src="liaotjl.avatar" alt />
          </div>
        </div>
      </div>

      <div class="body_bon">
        <div class="body_bder" v-if="userid == list">
          <div class="left">
            <span>今天</span>
          </div>
          <div class="right" @click="add">
            <div>
              <img src="@/assets/dea75399bac85feff054218bae61780.png" alt />
            </div>
          </div>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="userTable"
          :immediate-check="false"
        >
          <div class="body_bder" v-for="(item, index) in list1" :key="index">
            <div class="left">
              <span>{{ item.show_day }}</span>
            </div>
            <div
              class="right"
              @touchstart="clicka(item)"
              @touchend="jj(item)"
              @click="tiaoz(item)"
              :class="item.hidden ? 'aa' : ''"
            >
              <div v-if="item.if_image == 1">
                <img :src="item.url" alt />
              </div>
              <div v-if="item.if_image == 2">
                <video width="10rem" height="auto" controls>
                  <source :src="item.url" type="video/mp4" />
                  <source :src="item.url" type="video/ogg" />
                  <source :src="item.url" type="video/webm" />
                  您的浏览器不支持 video 属性。
                </video>
              </div>
              <span>{{ item.content }}</span>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "mine",
  data() {
    return {
      fileList: [],
      liaotjl: {},
      tooken: {},
      list: "",
      userid: "",
      loading: false,
      finished: false,
      page: 1,
      list1: [],
      uCode: ""
    };
  },
  created() {
    if (localStorage.getItem("userid_obse")) {
      return;
    }
    this.getCode()
    if (!this.uCode) {
      //没有code进行授权跳转
      const redirect_uri = encodeURIComponent(location.href);
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww6c09e0292217ba48&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=#wechat_redirect`;
    }
  },
  watch: {
    async $route() {
      this.getCode()
      if (this.uCode) {
        //如果有code请求接口
        try {
          const data = qs.stringify({
            infocode: this.uCode,
          });
          const result = await this.axios({
            url: "/crm/Mymine/updateInfo",
            method: "POST",
            data,
          });
          if (result.data.code == 1) {
            localStorage.setItem("userid_obse", result.data.data.userid);
            localStorage.setItem(
              "account_id_obse",
              result.data.data.account_id
            );
            this.$router.push({
              name: "login",
            });
          } else if (result.data.code == 0) {
            const msg = "没有获取到用户信息，请联系企业管理员添加该应用";
            this.unAuthorized(msg);
          }
        } catch (error) {}
      }
    },
  },
  mounted() {
    if (this.$route.query.account_id) {
      localStorage.setItem("account_id", this.$route.query.account_id);
      localStorage.setItem("userid", this.$route.query.userid);
    }
    this.userTable();
  },
  methods: {
    unAuthorized(msg) {
      // 无法获取到用户信息给予提示，并关闭浏览器
      this.$dialog({
        message: msg,
      }).then(() => {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              weixin_ClosePage,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", weixin_ClosePage);
            document.attachEvent("onWeixinJSBridgeReady", weixin_ClosePage);
          }
        } else {
          WeixinJSBridge.call("closeWindow");
        }
      });
    },
    userTable() {
      let userid_obse = window.localStorage.getItem("userid_obse");
      this.list = userid_obse;
      let account_id = window.localStorage.getItem("account_id");
      let userid = window.localStorage.getItem("userid");
      this.userid = userid;
      this.axios
        .post(
          "/crm/CircleFriends/CircleFriends",
          qs.stringify({
            account_id: account_id,
            userid: userid,
            page: this.page,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.finished = true;
          }
          if (!this.liaotjl.avatar) {
            this.liaotjl.avatar = res.data.data.avatar;
            this.liaotjl.name = res.data.data.name;
          }
          const list = res.data.data.list;
          this.list1 = this.list1.concat(list);
          this.loading = false;

          this.page++;
        })
        .catch(function (err) {});
    },
    afterRead(file) {},
    skip() {},
    clicka(item) {
      item.hidden = true;
    },
    jj(item) {
      item.hidden = false;
    },
    tiaoz(item) {
      let account_id_obse = window.localStorage.getItem("account_id_obse");
      let userid_obse = window.localStorage.getItem("userid_obse");
      let account_id = window.localStorage.getItem("account_id");
      let userid = window.localStorage.getItem("userid");
      this.$router.replace({
        path: "/circledetails",
        query: {
          account_id: account_id,
          userid: userid,
          item: item,
          account_id_obse: account_id_obse,
          userid_obse: userid_obse,
        },
      });
    },
    add() {
      let account_id = window.localStorage.getItem("account_id");
      let userid = window.localStorage.getItem("userid");
      this.$router.replace({
        path: "/circleadd",
        query: {
          account_id: account_id,
          userid: userid,
        },
      });
    },
    getCode() {
      // const url = "https://work.sgcchn.com/disttow/?code=RsYri_VNHoHnNn97ykiznohjv6eftsvkOaUUVJE0-OY&state="
      const url = location.href;
      var temp1 = url.split("?");
      var pram = temp1[1];
      var keyValue = pram.split("&");
      var obj = {};
      for (var i = 0; i < keyValue.length; i++) {
        var item = keyValue[i].split("=");
        var key = item[0];
        var value = item[1];
        obj[key] = value;
      }
      this.uCode = obj.code.split("#")[0]
    },
  },
};
</script>
<style scoped>
.nav {
  width: 100%;
  height: 20rem;
  position: relative;
}
.nav > img {
  width: 100%;
  height: 20rem;
}
.home {
  position: absolute;
  width: 5rem;
  height: 3rem;
  /* background-color: yellow; */
  top: 1rem;
  left: 2rem;
  font-size: 2.6rem;
}
.name {
  width: 100%;
  height: 10rem;
  position: absolute;
  bottom: -5rem;
  right: 0;
}
.name_img {
  position: relative;
  width: 100%;
  height: 100%;
}
.name_img > span {
  position: absolute;
  right: 7rem;
  color: #fff;
  top: 2rem;
}
.name_img > img {
  width: 5rem;
  height: 5rem;
  position: absolute;
  right: 1rem;
  top: 2rem;
}
.body_bon {
  margin-top: 5rem;
  width: 100%;
  /* height: 100%; */
  /* background-color: red; */
}
.body_bder {
  width: 80%;
  margin: 1rem;
  display: flex;
  align-items: flex-start;
}
.left {
  display: inline-block;
  width: 8rem;
}
.left > span {
  color: #282828;
  font-size: 2rem;
  font-weight: 900;
}
.right {
  display: inline-block;
  width: 23rem;
  /* margin-left: 2rem; */
  display: flex;
  align-items: flex-start;
  /* word-break: break-all; */
  margin-bottom: 1rem;
  margin-left: 2rem;
}

.right > div > img {
  width: 6rem;
  height: 6rem;
}
.right > span {
  margin-left: 1rem;
  font-size: 1.4rem;
  color: #282828;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 300;
}
.aa {
  background-color: rgb(229, 229, 229);
}
</style>
